import React from "react";
import { useParams } from "react-router-dom";
import CreateNewtestcaseView from "./CreateNewtestcaseView";

interface routerParams {
  moduleId: string;
  requirementId: string;
}

const TestcaseResultView = () => {
  const params = useParams<{ moduleId?: string; requirementId?: string }>();
  const moduleId = params.moduleId;
  const requirementId = params.requirementId;

  return (
    <CreateNewtestcaseView
      moduleId={moduleId || ""}
      requirementId={requirementId || ""}
    />
  );
};

export default TestcaseResultView;
